import React from 'react';
import { Card, CardProps, Container, Row } from 'react-bootstrap';
import {
  FaArrowRight,
  FaCircleArrowDown,
  FaRegCalendar,
  FaCalendarCheck,
  FaRegCircleCheck,
  FaRegClock,
  FaPlay,
  FaCity,
} from 'react-icons/fa6';
import { useTheme } from 'styled-components';

interface CardFaseProps extends CardProps {
  titulo: string;
  status: boolean;
  dataEntrada: string;
  dias: string;
  estimativaDias?: string;
  areaResponsavel?: string;
  isUltimoItem?: boolean;
  dataSaida: string;
}

function CardFase({
  titulo,
  status,
  dataEntrada,
  dias,
  estimativaDias,
  areaResponsavel,
  dataSaida,
  isUltimoItem,
  ...props
}: CardFaseProps) {
  const theme = useTheme();

  const getColorProfile = (status: boolean, isUltimoItem?: boolean) => {
    if (status && isUltimoItem) {
      return {
        icon: <FaPlay size={35} />,
        color: theme.colors.amarelogov,
        textColor: theme.colors.amarelogov,
        orderWidth: '3px',
        borderColor: theme.colors.amarelogov,
        borderStyle: 'solid',
      };
    } else if (status) {
      return {
        icon: <FaRegCircleCheck size={35} />,
        color: theme.colors.card.textoAzul,
        textColor: theme.colors.card.textoAzul,
        borderWidth: '1px',
        borderColor: theme.colors.card.borda,
        borderStyle: 'solid',
      };
    } else {
      return {
        icon: <FaRegClock size={35} />,
        color: theme.colors.card.fundoCinza,
        textColor: theme.colors.card.fundoCinza,
        borderWidth: '1px',
        borderColor: theme.colors.card.borda,
        borderStyle: 'solid',
      };
    }
  };

  const colorProfile = getColorProfile(status, isUltimoItem);

  return (
    <Card
      style={{
        minHeight: '12rem',
        margin: '0',
        padding: '0',
        borderRadius: '0',
        borderColor: colorProfile.borderColor,
        borderWidth: colorProfile.borderWidth,
        borderStyle: colorProfile.borderStyle,
        cursor: 'pointer',
      }}
      {...props}
    >
      <Card.Body className="m-0 p-0">
        <Container
          style={{
            display: 'grid',
            gridTemplateColumns: '50 50',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            minHeight: '12rem',
          }}
        >
          <Row
            className="mt-3"
            style={{
              display: 'flex',
              width: '100%',
              height: '6rem',
              color: colorProfile.color,
              fontWeight: 'bold',
              alignItems: 'center',
              alignContent: 'flex-start',
              justifyContent: 'flex-start',
              margin: '0 auto',
            }}
          >
            {colorProfile.icon}
            <span
              style={{
                fontSize: '0.85rem',
                fontWeight: 'bold',
                textAlign: 'center',
                marginTop: '1rem',
                color: colorProfile.textColor,
              }}
            >
              {titulo}
            </span>
          </Row>
          <Container
            style={{
              display: 'flex',
              width: '100%',
              height: '6rem',
              flexDirection: 'column',
              marginBottom: '0',
              padding: '1rem',
              gap: '0.1rem',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <Row
              style={{
                display: 'flex',
                marginBottom: '0.05rem',
                width: '100%',
                height: '100%',
              }}
            >
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <FaCircleArrowDown
                  style={{
                    marginRight: '0.5rem',
                    minWidth: '15px',
                    color: colorProfile.textColor,
                  }}
                />
                {dataEntrada}
              </span>
            </Row>
            <Row
              style={{
                display: 'flex',
                marginBottom: '0.05rem',
                width: '100%',
                height: '100%',
              }}
            >
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <FaArrowRight
                  style={{
                    marginRight: '0.5rem',
                    minWidth: '15px',
                    color: colorProfile.textColor,
                  }}
                />
                {dataSaida}
              </span>
            </Row>
            <Row
              style={{
                display: 'flex',
                marginBottom: '0.05rem',
                width: '100%',
                height: '100%',
              }}
            >
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <FaRegCalendar
                  style={{
                    marginRight: '0.5rem',
                    minWidth: '15px',
                    color: colorProfile.textColor,
                  }}
                />
                {dias}
              </span>
            </Row>
            {estimativaDias ? (
              <Row
                style={{
                  display: 'flex',
                  marginBottom: '0.05rem',
                  width: '100%',
                  height: '100%',
                }}
              >
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <FaCalendarCheck
                    style={{
                      marginRight: '0.5rem',
                      minWidth: '15px',
                      color: colorProfile.textColor,
                    }}
                  />
                  {estimativaDias}
                </span>
              </Row>
            ) : (
              <></>
            )}
            {areaResponsavel ? (
              <Row
                style={{
                  display: 'flex',
                  marginBottom: '0.05rem',
                  width: '100%',
                  height: '100%',
                }}
              >
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <FaCity
                    style={{
                      marginRight: '0.5rem',
                      minWidth: '15px',
                      color: colorProfile.textColor,
                    }}
                  />
                  {areaResponsavel}
                </span>
              </Row>
            ) : (
              <></>
            )}
          </Container>
        </Container>
      </Card.Body>
    </Card>
  );
}

export default CardFase;
